<template>
  <!-- <v-footer padless color="transparent"> -->
  <!-- <v-row justify="center" no-gutters> -->
  <div class="footer-bar">
    <div class="footer-group">
      <div class="game-nav px-2 w-100 footer-group-item">
        <nuxt-link
          v-for="(item, index) in footer"
          :key="index"
          :to="item.link"
          class="footer-tab d-flex"
          tabindex="0"
          aria-selected="false"
          role="tab"
        >
          <div class="d-flex footer-item">
            <div
              class="v-image v-responsive rounded-t-lg justify-content-center theme--dark"
              style="height: 25px; width: 50px"
            >
              <div
                class="v-image__image v-image__image--contain"
                :style="{
                  backgroundImage: `url(${getImage(item)})`,
                  backgroundPosition: 'center center'
                }"
              ></div>
            </div>
            <span>
              {{ item.title }}
            </span>
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
  <!-- </v-row> -->
  <!-- </v-footer> -->
</template>
<script>
export default {
  data() {
    return {
      footer: [
        {
          title: 'Sportsbook',
          src: 'sportsbook.png',
          link: '/premium-sportsbook'
        },
        // {
        //   title: 'Live Card',
        //   src: 'live-card.png',
        //   link: '/live-cards/98789'
        // },
        {
          title: 'Live Casino',
          src: 'live-casino.png',
          link: '/markets/live-casino'
        },
        {
          title: 'Slot Games',
          src: 'slot-games.png',
          link: '/casino-slots'
        },
        {
          title: 'Crash Games',
          src: 'crash_games.png',
          link: '/crash-games'
        }
      ]
    }
  },
  methods: {
    getImage(img) {
      return require(`@/assets/images/sportsbook-categories/${img.src}`)
    }
  }
}
</script>
<style>
.footer-bar {
  /* background: #000; */
  width: 100%;
  background-color: #1e1e1e;
  height: 59px;
  contain: content;
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
}
.footer-group {
  width: 100%;
  display: flex;
  flex: 1 0 auto;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  background: linear-gradient(to top, rgba(10, 10, 10, 0.5) 50%, #323232 100%);
  border-bottom: 1px solid #333;
  border-top: 1px solid #4c4c4c;
}
.footer-item {
  flex-direction: column;
  align-items: center;
}
.footer-item span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}
.footer-group-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-tab:before {
  background-color: currentColor;
  bottom: 0;
  content: '';
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.footer-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  width: 25%;
  border-right: 1px solid rgb(110 110 110);
}
.footer-tab:nth-child(4) {
  border-right: none;
}
.spacer {
  background-color: gray;
  flex-grow: 0 !important;
  height: 100%;
  margin: 0.5rem 0;
  width: 1px;
}
/* .v-tab {
  display: flex;
  flex-direction: column !important;
  animation: slideUp 0.6s linear;
} */
.v-responsive__sizer {
  flex: 1 0 0px;
}
</style>
